import hash from 'hash.js'

export function validateEmail (value) {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(value)
}

export function isInputEmpty (text) {
  // Remove HTML tags
  const strippedText = text.replace(/<[^>]*>/g, '')

  // Trim whitespace
  const trimmedText = strippedText.trim()

  // Check if the resulting string is empty
  return trimmedText.length === 0
}

export function generateChecksum (data) {
  return hash.sha256().update(data).digest('hex')
}
